import React from 'react';
import { TableCell, TableRow, Box } from '@mui/material';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import SortableHeader from './sortable-header';
import { SortConfig } from './employee-utils';
import { useTranslation } from 'react-i18next';

interface EmployeeTableHeaderRowProps {
  sortConfig: SortConfig;
  requestSort: (key: string) => void;
}

const EmployeeTableHeaderRow: React.FC<EmployeeTableHeaderRowProps> = ({
  sortConfig,
  requestSort
}) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell sx={{ height: '80px', width: '5%' }} />
      <TableCell sx={{ height: '80px', width: '15%' }}>
        <ResponsiveTypography sx={{ fontWeight: 'bold' }} verySmallXs>
          <SortableHeader
            label={t('name')}
            keyName="name"
            currentSort={sortConfig.primary}
            onSort={requestSort}
          />
        </ResponsiveTypography>
      </TableCell>
      <TableCell sx={{ height: '80px', width: '15%' }}>
        <ResponsiveTypography sx={{ fontWeight: 'bold' }} verySmallXs>
          <SortableHeader
            label={t('email')}
            keyName="email"
            currentSort={sortConfig.primary}
            onSort={requestSort}
          />
        </ResponsiveTypography>
      </TableCell>
      <TableCell sx={{ height: '80px', width: '10%' }}>
        <ResponsiveTypography sx={{ fontWeight: 'bold' }} verySmallXs>
          <SortableHeader
            label={t('user_role')}
            keyName="role"
            currentSort={sortConfig.primary}
            onSort={requestSort}
          />
        </ResponsiveTypography>
      </TableCell>
      <TableCell
        sx={{
          height: '80px',
          width: '15%',
          // paddingRight: { xs: 0, sm: 8 },
          marginRight: '-10px'
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <ResponsiveTypography sx={{ fontWeight: 'bold' }} verySmallXs>
            <SortableHeader
              label={t('user_confirmed')}
              keyName="confirmed"
              currentSort={sortConfig.primary}
              onSort={requestSort}
            />
          </ResponsiveTypography>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default EmployeeTableHeaderRow;
